import React from "react";

function IndividualIcon() {
  return (
    <svg
      width="18"
      height="20"
      viewBox="0 0 18 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.75 18.75V16.75C16.75 15.6891 16.3286 14.6717 15.5784 13.9216C14.8283 13.1714 13.8109 12.75 12.75 12.75H4.75C3.68913 12.75 2.67172 13.1714 1.92157 13.9216C1.17143 14.6717 0.75 15.6891 0.75 16.75V18.75M12.75 4.75C12.75 6.95914 10.9591 8.75 8.75 8.75C6.54086 8.75 4.75 6.95914 4.75 4.75C4.75 2.54086 6.54086 0.75 8.75 0.75C10.9591 0.75 12.75 2.54086 12.75 4.75Z"
        stroke="#667085"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default IndividualIcon;
